import Store from '@/store';

export function undoError() {
  Store.commit('undoError');
}

export function setError(message: string) {
  Store.commit('onError', message);
}
